<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
                @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs"/>
                    <b-container class="mb-7 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t('fund_raising.title') }}</h3>
                            <h4 class="mt-2">{{ $t('fund_raising.organizer') }}</h4>
                            <span>Fair Donation ry</span>
                            <h4 class="mt-2">{{ $t('fund_raising.contact') }}</h4>
                            <div>Fair Donation ry</div>
                            <div>c/o Työpajankatu 13</div>
                            <div>00580 Helsinki</div>
                            <div>info@fairdonation.fi</div>
                            <div>johannes@fairdonation.org</div>
                            <h4 class="mt-2">{{ $t('fund_raising.purpose_title')}}</h4>
                            <ul>
                                <li>{{$t('fund_raising.purpose1')}}</li>
                                <li>{{$t('fund_raising.purpose2')}}</li>
                                <li>{{$t('fund_raising.purpose3')}}</li>
                                <li>{{$t('fund_raising.purpose4')}}</li>
                                <li>{{$t('fund_raising.purpose5')}}</li>
                                <li>{{$t('fund_raising.purpose6')}}</li>
                            </ul>
                            {{ $t('fund_raising.summary') }}
                            <h4 class="mt-2">{{ $t('fund_raising.license')}}</h4> RA/2021/1199
                        </b-col>
                    </b-container>
                    <b-container class="pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                        </b-col>
                    </b-container>
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import TopBar from "../components/TopBar";
import FooterArea from "../components/FooterArea";
import BreadCrumbs from "@/components/BreadCrumbs";
import {alertMixin} from "@/mixins/AlertMixin";
import Alert from "@/components/Alert";

export default {
    name: "FundRaisingInfoView",
    mixins: [alertMixin],
    components: {Alert, BreadCrumbs, FooterArea, TopBar, Login},
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            breadcrumbs: [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "breadcrumbs.funds",
                    translate: true,
                    route: 'info-view',
                    disabled: true,
                    active: true
                }]
        }
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        setCategory(category) {
            this.category = category
            this.$router.push({name: 'category-organizations-view', params: {id: category}})
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },
    }
}
</script>

<style scoped>

</style>